import React from "react";
import Logo from "../Assets/logo.png";
import SignUpImg from "../Assets/SignUpImg.png";
import { Link } from "react-router-dom";

export default function SignIn() {
  return (
    <div className="flex items-center">
      <div className="w-[50%]">
        <div className="flex items-center justify-center h-[100vh]">
          <div className="w-[32rem]">
            <img className="w-[7.6rem] h-[2.25]" src={Logo} />
            <div className="mt-5">
              <h2 className="text-[1.2rem] font-[800] text-[#111928]">
                Login to AI People Ecosystem
              </h2>
            </div>
            <div>
              <form>
                <div className="mt-5">
                  <div className="flex items-center flex-col justify-between">
                    <div className="flex items-start flex-col gap-1">
                      <label className="text-[0.95rem] text-[#111928] font-[500]">
                        Email
                      </label>
                      <input
                        className="w-[32rem] h-[2.6rem] border-[1px] border-[#D1D5DB] bg-[#F9FAFB] text-[0.90rem] text-[#6B7280] pl-3 outline-none rounded-[8px]"
                        type="text"
                        placeholder="name@example.com"
                      />
                    </div>
                    <div className="flex items-start flex-col gap-1 mt-6">
                      <label className="text-[0.95rem] text-[#111928] font-[500]">
                        Password
                      </label>
                      <input
                        className="w-[32rem] h-[2.6rem] border-[1px] border-[#D1D5DB] bg-[#F9FAFB] text-[0.90rem] text-[#6B7280] pl-3 outline-none rounded-[8px]"
                        type="password"
                        placeholder="••••••••••"
                      />
                    </div>
                  </div>
                  <div className="flex items-center justify-between mt-5">
                    <div className="flex items-center gap-2">
                      <input
                        className="w-[1.1rem] h-[1.1rem] accent-[#942A27]"
                        type="checkbox"
                      />
                      <label className="text-[0.94rem] text-[#6B7280]">
                        Remember me
                      </label>
                    </div>
                    <p className="text-[0.90rem] text-[#942A27] font-[500]">
                      Forgot password?
                    </p>
                  </div>
                  <div className="mt-6">
                    <Link to="/workspace">
                      <button className="w-full h-[2.5rem] bg-[#942A27] rounded-[8px] text-[0.95rem] text-white font-[500]">
                        Log In
                      </button>
                    </Link>
                  </div>
                  <div>
                    <p className="text-[0.95rem] text-[#6B7280] mt-5">
                      Don’t have an account yet?{" "}
                      <span className="text-[#942A27]">Sign up</span>
                    </p>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          backgroundImage: `url(${SignUpImg})`,
          backgroundSize: "100% 100%",
        }}
        className="w-[50%] h-[100vh]"
      ></div>
    </div>
  );
}
